import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import Enums from '../../shared/enum/enums';
import { AppInjector } from '../service/app-injector.service';
import { UrlParameterMapperService } from '../../shared/service/url-state/url-parameter-mapper.service';

@Injectable({
  providedIn: 'root',
})
export class BaseGuard {
  protected readonly router: Router;
  protected readonly urlParameterMapperService: UrlParameterMapperService;

  protected code: any;

  constructor() {
    this.router = AppInjector.getInjector().get(Router);
    this.urlParameterMapperService = AppInjector.getInjector().get(UrlParameterMapperService);
  }

  protected validateParam(urlParameter: Enums.UrlParameter, next: ActivatedRouteSnapshot): boolean | UrlTree {
    const paramValue = next.params[urlParameter];
    if (!paramValue) {
      return false;
    }
    try {
      this.code = this.urlParameterMapperService.mapUrlToId(urlParameter, paramValue);
    } catch (e) {
      return this.redirectToError(e.message);
    }

    return true;
  }

  protected mapToCommands(route: any[]): string[] {
    if (!route || route.length !== 4) {
      console.error('invalid route');
      return ['error'];
    }

    return [
      this.urlParameterMapperService.mapIdToUrl(route[0], Enums.UrlParameter.workspace),
    ];
  }

  protected redirectToError(error: string): UrlTree {
    console.error(error);
    return this.router.createUrlTree(['error']);
  }
}
